import {Injectable} from "@angular/core";
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";


@Injectable({
  providedIn: 'root'
})

export class NgxModalCustomService {

  constructor(
    private _modalService: NgbModal,
  ) {
  }

  /**
   * Mở modal với cấu hình mặc định cho phép đóng bằng click bên ngoài hoặc phím Esc.
   * @param content Nội dung của modal
   * @param options Các tùy chọn của modal (nếu có)
   */
  openDefault(content: any, options?: NgbModalOptions): NgbModalRef {
    const modalOptions: NgbModalOptions = {
      ...options,
      backdrop: true,
      keyboard: true,
    };
    return this._modalService.open(content, modalOptions);
  }

  /**
   * Mở modal với các tùy chọn hiển thị được truyền vào từ bên ngoài.
   * @param content Nội dung của modal
   * @param options Các tùy chọn của modal (nếu có)
   */
  openIntro(content: any, options?: NgbModalOptions): NgbModalRef {
    const modalOptions: NgbModalOptions = {
      ...options,
      backdrop: true,
      keyboard: true,
    };
    return this._modalService.open(content, modalOptions);
  }

  /**
   * Đóng modal.
   */
  dismissAll(reason?: any) {
    return this._modalService.dismissAll(reason);
  }

  hasOpenModals(): boolean {
    return this._modalService.hasOpenModals();
  }
}
